// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.scale-wrapper[data-v-f258308a] {\n  transform: scale(0.8); /* 80% 크기로 축소 */\n  transform-origin: top; /* 축소 기준점 (좌상단) */\n  padding: 0 20px 0px 20px;\n  /* height: 985px !important; */\n}\n.h550[data-v-f258308a] {\n height: 550px !important;\n}\n.content_title_in[data-v-f258308a] {\n    margin: 1px 0 1px 0 !important;\n    font-size: 18px;\n    font-weight: 500;\n    color: #000;\n}\n", ""]);
// Exports
module.exports = exports;
